import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button } from "react-bootstrap";

import RemoveProductModal from "./RemoveProductModal";

const RemoveProduct = (props) => {
  const { onChange } = props;

  const [showAddClientModal, setShowAddClientModal] = useState(false);

  const onCreateClientComplete = async (client) => {
    console.log("product", client);
    onChange({ value: client.id, label: client.codice_ricambio });
  };

  return (
    <div className="flex justify-center items-center">
      <Button
        size="sm"
        variant="outline-primary"
        onClick={() => setShowAddClientModal(true)}
        className="text-xs md:text-base min-w-[150px] border-[#004b8f] hover:bg-[#004b8f] text-[#004b8f] hover:border-[#004b8f]"
      >
        Rimuovere Prodotto
      </Button>

      <RemoveProductModal
        show={showAddClientModal}
        handleClose={() => setShowAddClientModal(false)}
        onRemoveComplete={onCreateClientComplete}
      />
    </div>
  );
};

RemoveProduct.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default RemoveProduct;
